import VideoPlayer from './VideoPlayer';

const { registerPlugin } = wp.plugins;

wp.domReady(() => {
	registerPlugin('ib-video-player', {
		render: VideoPlayer,
		icon: '',
	});
});
